import { findAlternateId } from "encamp-shared/src/facilityAlternateId/findAlternateId";
import { TabProxy } from "encampy";
import { AlternateId } from "generated-graphql/graphql";

export async function automateCERSLogin({
  tab,
  username,
  password,
  facilityAlternateIds,
}: {
  tab: TabProxy;
  username: string;
  password: string;
  facilityAlternateIds?: AlternateId[];
}): Promise<void> {
  // Wait for the login page to load
  await tab.waitForElement("input#UserName", { timeout: 10000 });

  // Type in the username
  await tab.type("input#UserName", username);

  // Click Next
  await tab.click("button[type='submit'][value='Next']");

  await tab.waitForNavigation({ timeout: 10000 });

  // Type in the password
  await tab.type("input#Password", password);

  // Click Next
  await tab.click("button[type='submit'][value='Next']");

  // Wait for navigation to complete after login
  await tab.waitForNavigation({ timeout: 10000 });

  if (Array.isArray(facilityAlternateIds)) {
    const cersBusiness = findAlternateId(facilityAlternateIds, ["CERS_BUSINESS"]);
    const cers = findAlternateId(facilityAlternateIds, ["CERS"]);

    if (cersBusiness?.value && cers?.value) {
      await tab.navigate(`/${cersBusiness.value}/Facility/${cers.value}/DraftSubmittals`);
    } else if (cersBusiness?.value) {
      await tab.navigate(`/${cersBusiness.value}`);
    }
  }
}
